import { parseAlignmentSearch } from "../../lib/routerSearch";
import { parseReviewListSearch } from "./reviewListData";

export type ReviewMarkerSearch = ReturnType<typeof parseReviewListSearch> & {
  tab: "needs_review" | "reviewed" | "all";
  cell?: ReturnType<typeof parseAlignmentSearch>["cell"];
};

export function parseReviewMarkerSearch(
  search: Record<string, unknown>,
): ReviewMarkerSearch {
  const { cell } = parseAlignmentSearch(search);
  return {
    ...parseReviewListSearch(search),
    ...(cell ? { cell } : {}),
    tab:
      search.tab === "reviewed" || search.tab === "all"
        ? search.tab
        : ("needs_review" as const),
  };
}
